module.exports = __webpack_public_path__ + "img/service-241.a8f265d4.png";